<!-- Header -->
<div class="modal-header">

  <!-- Title -->
  <h6 class="modal-title" i18n="@@components.add_fields_modal.title">Add Field</h6>
  <!-- Title end -->

  <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="close()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<!-- Header end -->

<!-- Content -->
<div class="modal-body">
  <div class="grid-view-with-filter-column">
    <div class="filter-column-container">
      <!-- Left Column -->
      @if (filterColumnConfig) {
        <left-column class="col-auto left-column"
          [identifiers]="['filter']"
          [icons]="['filter']"
          #lc>
          @if (lc.show === 'filter' || !lc.show) {
            <filter-column
              [listFilter]=listFilter
              [filterConfig]="filterColumnConfig">
            </filter-column>
          }
        </left-column>
      }
      <!-- Left Column end -->
    </div>
    <div class="view-container">
      <div class="filter-tabs-container"></div>
      <div class="main-view">
        <div class="grid-card">
          <div class="grid-card-header">
            <div class="d-flex justify-content-between">
              <div class="d-flex justify-content-start scroll-container" style="overflow-x: scroll">
                <filter-tags [filterConfig]="filterColumnConfig" [openOnLoad]="true" class="d-flex flex-nowrap align-content-center align-items-center flex-grow-1"></filter-tags>
              </div>
              <div class="justify-content-end d-flex flex-row align-items-start ms-2">
                <filter-sorting [listFilter]="listFilter"
                  [filterConfig]="filterColumnConfig"
                ></filter-sorting>
              </div>
            </div>
          </div>
          <div class="grid-card-body">
            <ng-template #table_headers>
              <thead class="table-dark">
                <tr>
                  <th><div i18n="@@common.name">Name</div></th>
                  <th><div i18n="@@common.fields">Fields</div></th>
                  <th><div i18n="@@common.description">Description</div></th>
                  <th><div i18n="@@common.locales">Locales</div></th>
                  <th><div i18n="@@common.issuer">Issuer</div></th>
                  <th><div i18n="@@common.type">Type</div></th>
                  <th><div i18n="@@common.business_sectors">Business Sectors</div></th>
                  <th><div i18n="@@common.tags">Tags</div></th>
                  <th><div></div></th>
                </tr>
              </thead>
            </ng-template>

            <!-- Result -->
            @if (documentTypeFields?.getModels().length > 0 && !loading) {
              <div class="table-responsive-new scroll-horizontal">
                <table class="table-new">
                  <ng-template [ngTemplateOutlet]="table_headers"></ng-template>
                  <tbody>
                    @for (documentTypeField of documentTypeFields?.getModels(); track documentTypeField; let index = $index) {
                      <tr>
                        <td>
                          <list-data-with-tooltip [type]="'title'" [shouldTextClip]="true" [model]="documentTypeField"></list-data-with-tooltip>
                        </td>
                        <td>
                          <div>{{ documentTypeField.title }}</div>
                        </td>
                        <td>
                          <div>
                            @if (documentTypeField.description) {
                              <fa-icon [icon]="['fas', 'exclamation-circle']"
                                [fixedWidth]="true"
                                tooltip="{{ documentTypeField.description }}">
                              </fa-icon>
                            }
                          </div>
                        </td>
                        <td><div><locale-badges [locales]="documentTypeField.locales"></locale-badges></div></td>
                        <td><div>{{ documentTypeField.parent.tenant_id || documentTypeField.tenant_id }}</div></td>
                        <td><div>{{ type[documentTypeField.getType(tenant_id)] }}</div></td>
                        <td><div><business-sector-badges [businessSectors]="documentTypeField.business_sectors"></business-sector-badges></div></td>
                        <td><div><tag-badges [tags]="documentTypeField.tags"></tag-badges></div></td>
                        <td>
                          <div>
                            <div class="form-check">
                              <input type="checkbox"
                                [id]="'add-field-' + index"
                                class="form-check-input"
                                autocomplete="off"
                                (click)="handleFieldSelection($event, documentTypeField)"
                                [checked]="excludedFieldIds.includes(documentTypeField.id) || selectedFieldIds.includes(documentTypeField.id)"
                                [disabled]="excludedFieldIds.includes(documentTypeField.id) || disableButtons">
                              <label class="form-check-label" [for]="'add-field-' + index"></label>
                            </div>
                          </div>
                        </td>
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
            } @else {
              <div class="table-responsive-new">
                <table class="table-new">
                  <ng-template [ngTemplateOutlet]="table_headers"></ng-template>
                </table>
                <div class="alert alert-warning mt-3" role="alert">
                  @if (loading) {
                    <fa-icon class="me-1" [icon]="['fas', 'sync-alt']" [fixedWidth]="true" animation="spin"></fa-icon>
                  }
                  @if (loading) {
                    <ng-container i18n="@@common.loading_text">We're loading… please wait.</ng-container>
                  } @else {
                    <ng-container i18n="@@common.nothing_here">There's nothing here!</ng-container>
                  }
                </div>
              </div>
            }
            <!-- Result end -->

            <!-- No Result -->
            <!-- No Result end -->
          </div>
          <div class="grid-card-footer">
            @if (documentTypeFields?.getModels().length > 0) {
              <div>
                <list-pagination
                  [totalItems]="documentTypeFields?.getMeta().meta.stats.total.count"
                  [filterComponent]="filterComponent"
                  [pageNumber]="listFilter.page.number"
                  [pageSize]="listFilter.page.size"
                ></list-pagination>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Content end -->

<!-- Footer -->
<div class="modal-footer justify-content-end">
  <div class="d-flex">
    @if (bsModalRef && bsModalRef.content && bsModalRef.content.action_alternative) {
      <button type="button" class="button-secondary"
        style="margin-right: 8px;"
        (click)="alternativeAction()"
        [disabled]="disableButtons"
        ><span i18n="@@components.add_fields_modal.create_new_field">Create new field</span></button>
      }
      <button type="button"
        style="margin-right: 8px;"
        class="button-secondary-outlined"
        (click)="close()"
        [disabled]="disableButtons"
      i18n="@@common.cancel">Cancel</button>
      <button type="button"
        class="button-secondary"
        (click)="addSelectedFields()"
        [disabled]="selectedFields.length === 0 || disableButtons"
        >
        @if (disableButtons) {
          <fa-icon [icon]="['fas', 'sync-alt']" [fixedWidth]="true" animation="spin" class="me-1"></fa-icon>
        }
        <span i18n="@@components.add_fields_modal.submit">Add</span>
      </button>
    </div>
  </div>
  <!-- Footer end -->
